import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  Card,
  CardContent,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { School, GitHub, Launch, Coffee, LibraryAdd, Edit, Save, Send } from '@mui/icons-material';

const KankiSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ py: 8, px: { xs: 2, md: 4 } }}>
      <Box
        sx={{
          maxWidth: '1500px',
          mx: 'auto',
          backgroundColor: "rgba(255, 255, 255, 0.08)",
          borderRadius: "16px",
          boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
          backdropFilter: "blur(5px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          p: { xs: 3, md: 6 }
        }}
      >
        <Box sx={{ textAlign: 'center', maxWidth: '1200px', mx: 'auto' }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                component="h2"
                gutterBottom
                sx={{
                  fontWeight: 'bold',
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  color: 'white'
                }}
              >
                KAnki for Kindle
              </Typography>
              <Typography variant="h6" sx={{ mb: 3, color: 'rgba(255, 255, 255, 0.8)', fontSize: '1.1rem' }}>
                Universal Flashcard App for Jailbroken Kindle Devices
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.6, fontSize: '1.1rem' }}>
                KAnki is a spaced repetition flashcard application designed specifically for jailbroken Kindle devices.
                Learn vocabulary in any language through digital flashcards with optimized spaced repetition.
              </Typography>

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  startIcon={<GitHub />}
                  href="https://github.com/crizmo/KAnki"
                  target="_blank"
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.2)',
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' }
                  }}
                >
                  View on GitHub
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<Coffee />}
                  href="https://ko-fi.com/kurizu"
                  target="_blank"
                  sx={{
                    borderColor: 'rgba(255,255,255,0.5)',
                    color: 'white',
                    '&:hover': {
                      borderColor: 'white',
                      bgcolor: 'rgba(255,255,255,0.1)'
                    }
                  }}
                >
                  Support on Ko-fi
                </Button>
                {/* one more buttooon to navigate to /kanki */}
                <Button
                  variant="outlined"
                  startIcon={<Launch />}
                  href="/kanki"
                  sx={{
                    borderColor: 'rgba(255,255,255,0.5)',
                    color: 'white',
                    '&:hover': {
                      borderColor: 'white',
                      bgcolor: 'rgba(255,255,255,0.1)'
                    }
                  }}
                >
                  Learn More
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card sx={{
                bgcolor: 'rgba(255,255,255,0.1)',
                color: 'white',
                borderRadius: 2,
                border: '1px solid rgba(255, 255, 255, 0.1)',
                height: 'fit-content'
              }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                    ✨ Uben + KAnki Workflow
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2, opacity: 0.9, fontSize: '1.1rem' }}>
                    Use Uben as a companion tool to manage your KAnki decks:
                  </Typography>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Box sx={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        bgcolor: 'rgba(255,255,255,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        flexShrink: 0
                      }}>
                        1
                      </Box>
                      <LibraryAdd sx={{ fontSize: 18, color: 'rgba(255,255,255,0.8)', flexShrink: 0 }} />
                      <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.3, fontSize: '1.1rem' }}>
                        Import .apkg files into Uben
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Box sx={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        bgcolor: 'rgba(255,255,255,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        flexShrink: 0
                      }}>
                        2
                      </Box>
                      <Edit sx={{ fontSize: 18, color: 'rgba(255,255,255,0.8)', flexShrink: 0 }} />
                      <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.3, fontSize: '1.1rem' }}>
                        Edit cards with modern UI
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Box sx={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        bgcolor: 'rgba(255,255,255,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        flexShrink: 0
                      }}>
                        3
                      </Box>
                      <Save sx={{ fontSize: 18, color: 'rgba(255,255,255,0.8)', flexShrink: 0 }} />
                      <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.3, fontSize: '1.1rem' }}>
                        Export to kanki_config.js
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Box sx={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        bgcolor: 'rgba(255,255,255,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        flexShrink: 0
                      }}>
                        4
                      </Box>
                      <Send sx={{ fontSize: 18, color: 'rgba(255,255,255,0.8)', flexShrink: 0 }} />
                      <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.3, fontSize: '1.1rem' }}>
                        Transfer to your Kindle
                      </Typography>
                    </Box>
                  </Box>

                  <Typography variant="body2" sx={{ mt: 2, opacity: 0.9, fontSize: '1.1rem' }}>
                    Better editing experience, no manual typing on Kindle!
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default KankiSection;